export const getFormattedCarrierName = carrier =>
  `${carrier?.name}${carrier?.service_name ? ` | ${carrier?.service_name}` : ''}`
